import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PaymentForm from './PaymentForm';
import Product from './Product';
import axios from 'axios'
import Toolbar from '../../components/Toolbar/Toolbar'
import Logout from '../../containers/Login/Logout'
const products = [
  {
    key: 0,
    price: '$1.99',
    name: 'Cryptologics-ai Limited Trial Subscription',
    interval: 'month',
    billed: 'monthly: Trading limit is USD 4000',
  },
/*
  {
    key: 1,
    price: '$1.99',
    name: 'Cryptologics-ai Tier 2 subscription',
    interval: 'month',
    billed: 'monthly: Trading limit is USD 20000',
  },

  {
    key: 2,
    price: '$1.99',
    name: 'Cryptologics-ai Tier 3 subscription',
    interval: 'month',
    billed: 'monthly: Trading limit is USD 50000',
  },
  */
];




function getcustomer(setCustomer) {
  var url_get_customer = process.env.REACT_APP_API_BASEURL  + "/api/get-customer";
  var email = localStorage.getItem('email');
  var customer = []
  axios.get(url_get_customer, {
    params:{email: email},
    headers: {"Authorization": localStorage.getItem('token')}
})
  .then((response) => {
     customer.push(response.data.customer.data[0])
    setCustomer(response.data.customer.data[0])
  })

  return customer

}



 
function Prices() {
  const [productSelected, setProduct] = useState(null);
  const [customer, setCustomer] = useState(null);


  useEffect(() => {
     getcustomer(setCustomer)

  }, []);



  function handleClick(key) {
    setProduct(products[key]);
   }

  return (

    <div>

<Toolbar button={<Logout ></Logout>}></Toolbar>


    <div className="p-6">
      <div className="flex flex-wrap justify-center">
        <div className="md:w-1/3 w-full mr-4 md:mb-8">
          <div className="text-center text-indigo-600 font-bold text-2xl mt-4 mb-6">
            Subscribe to premium 
          </div>

          <div className="justify-center mb-8">
            {products.map((product, index) => {
              return (
                <Product
                  key={index}
                  product={product}
                  handleClick={handleClick}
                />
              );
            })}
          </div>
          {productSelected ? (
            <PaymentForm
              productSelected={productSelected}
              customer={customer}
            />

          ) : null}
        </div>
      </div>

    </div>
    </div>

  );
}

export default withRouter(Prices);